const escapeHtml = (text) =>
    String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

const decodeBlockquotes = (text) => text.replace(/&gt;/g, '>');

export {escapeHtml, decodeBlockquotes};
